import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TrashIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TrashIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.1852 9.38992H4.81485C3.86604 9.38992 3.09375 8.61764 3.09375 7.66882V6.68961C3.09375 5.74081 3.86603 4.96851 4.81485 4.96851H19.1852C20.1341 4.96851 20.9063 5.7408 20.9063 6.68961V7.66882C20.9063 8.61763 20.1341 9.38992 19.1852 9.38992ZM4.81485 6.47485C4.69619 6.47485 4.60008 6.57095 4.60008 6.68962V7.66883C4.60008 7.78749 4.69618 7.88361 4.81485 7.88361H19.1852C19.3039 7.88361 19.4 7.7875 19.4 7.66883V6.68962C19.4 6.57096 19.3039 6.47485 19.1852 6.47485H4.81485Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4248 6.42238H8.57527C8.15946 6.42238 7.8221 6.08502 7.8221 5.66922V3.84712C7.8221 2.82868 8.65078 2 9.66922 2H14.3309C15.3493 2 16.178 2.82868 16.178 3.84712V5.66922C16.178 6.08502 15.8406 6.42238 15.4248 6.42238ZM9.32843 4.91605H14.6717V3.84712C14.6717 3.65932 14.5187 3.50633 14.3309 3.50633H9.66921C9.48141 3.50633 9.32842 3.65931 9.32842 3.84712L9.32843 4.91605Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0479 22H6.95224C6.01814 22 5.239 21.2704 5.1777 20.3382L4.41081 8.68628C4.39708 8.47837 4.47014 8.2739 4.61283 8.1219C4.75503 7.96989 4.9541 7.88359 5.1625 7.88359H18.8376C19.046 7.88359 19.2451 7.9699 19.3873 8.1219C19.53 8.2739 19.603 8.47837 19.5893 8.68628L18.8224 20.3387C18.7611 21.2704 17.982 22 17.0479 22ZM5.96665 9.38992L6.68108 20.2397C6.6904 20.3824 6.80955 20.4937 6.95224 20.4937H17.0479C17.1905 20.4937 17.3097 20.3824 17.319 20.2402L18.0334 9.38992H5.96665Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0003 19.1251C11.5845 19.1251 11.2471 18.7878 11.2471 18.372V11.4008C11.2471 10.985 11.5845 10.6477 12.0003 10.6477C12.4161 10.6477 12.7535 10.985 12.7535 11.4008V18.372C12.7535 18.7878 12.4161 19.1251 12.0003 19.1251Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1512 19.1251C15.1385 19.1251 15.1257 19.1246 15.113 19.1242C14.6972 19.1031 14.3775 18.7495 14.3985 18.3342L14.7506 11.3631C14.7717 10.9472 15.1267 10.6413 15.5405 10.6486C15.9563 10.6697 16.2761 11.0232 16.255 11.4386L15.9029 18.4097C15.8828 18.8123 15.5499 19.1251 15.1512 19.1251Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.86555 19.1251C8.4669 19.1251 8.13395 18.8123 8.11385 18.4097L7.76227 11.4386C7.74119 11.0233 8.06089 10.6697 8.4767 10.6486C8.89496 10.6437 9.24604 10.9477 9.26664 11.3631L9.61822 18.3342C9.6393 18.7495 9.3196 19.1031 8.90379 19.1242C8.89103 19.1247 8.8783 19.1251 8.86555 19.1251Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TrashIcon;
